import { createContext } from 'react';

const initialPropertyState = {};
const PropertyMapContext = createContext(initialPropertyState);

export default PropertyMapContext;
